import { logger } from '@parrot-software/observability';

import type { IInvoiceDataApiPort } from '@subscriptions/application/ports';
import type { InvoiceDataViewDto } from '@subscriptions/application/dtos';
import { mapInvoiceDataToViewDto } from '@subscriptions/application/mappers';
import { extractErrorAttributes } from '@subscriptions/application/utils';

const invoiceLog = logger.forDomain('SUB', { subdomain: 'billing' });

/**
 * Use case for listing all invoice data of an organization.
 *
 * @param port - Invoice data API port
 * @returns Use case executor
 */
export const listInvoiceDataUseCase = (port: IInvoiceDataApiPort) => {
  const execute = async (): Promise<InvoiceDataViewDto[]> => {
    try {
      const dataList = await port.list();
      return dataList.map(mapInvoiceDataToViewDto);
    } catch (error) {
      invoiceLog.error('listInvoiceData', extractErrorAttributes(error));
      throw error;
    }
  };

  return { execute };
};
